var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"inset":"","input-value":_vm.selectedOptions,"label":_vm.option.name,"loading":_vm.loading,"hide-details":"","dense":""},on:{"change":_vm.updated}})
}
var staticRenderFns = []

export { render, staticRenderFns }